/**
 * String the paths from an array of PathValues
 * @param {Array<PathValue>} pathValues - the PathValues to process
 * @returns {Array<*>} - the extracted values
 */
function toValues(pathValues) {
  return pathValues.map(({ value }) => value);
}

module.exports = toValues;
